"use client"
import Image from 'next/image';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import Reveal from './Reveal';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import Marquee from 'react-fast-marquee';
import PartnerItem from './PartnerItem';

// const items = [
//   { imgUrl: '/images/icons/egabid.svg' },
//   { imgUrl: '/images/icons/eureka.svg' }, 
//   { imgUrl: '/images/icons/pindias.svg' }, 
//   { imgUrl: '/images/icons/qualcomm.svg' }, 
//   { imgUrl: '/images/icons/Rapitalbank.svg' }, 
//   { imgUrl: '/images/icons/Vitala.svg' },
// ]

const items = [
    {
      imgUrl: "/images/partner/egabid-1.svg",
      to: "https://x.com/Rivalz_AI",
    },
    {
      imgUrl: "/images/partner/egabid-2.svg",
      to: "https://x.com/cryptodailyuk",
    },
    {
      imgUrl: "/images/partner/egabid-3.svg",
      to: "https://x.com/VoltixAI",
    },
    {
      imgUrl: "/images/partner/egabid-4.svg",
      to: "https://x.com/GT_Protocol",
    },
    {
      imgUrl: "/images/partner/egabid-5.svg",
      to: "https://x.com/PathPulse_ai",
    },
    {
      imgUrl: "/images/partner/egabid-6.svg",
      to: "https://x.com/soonchain_ai",
    },
    {
      imgUrl: "/images/partner/egabid-7.svg",
      to: "https://x.com/ClusterProtocol",
    },
    {
      imgUrl: "/images/partner/egabid-8.svg",
      to: "https://x.com/flow3_tech",
    },
    {
      imgUrl: "/images/partner/egabid-9.svg",
      to: "https://x.com/pencilsprotocol",
    },
    {
      imgUrl: "/images/partner/egabid-10.svg",
      to: "https://x.com/uquidcard",
    },
    {
      imgUrl: "/images/partner/egabid-11.svg",
      to: "https://x.com/HookedProtocol",
    },
    {
      imgUrl: "/images/partner/egabid-12.svg",
      to: "https://x.com/Phron_AI",
    },
    {
      imgUrl: "/images/partner/egabid-13.svg",
      to: "https://x.com/Friend3AI",
    },
    {
      imgUrl: "/images/partner/egabid-14.svg",
      to: "https://x.com/PolyhedraZK",
    },
    {
      imgUrl: "/images/partner/egabid-15.svg",
      to: "https://x.com/krain_ai",
    },
]
// 1 ,3 , 45, 789 13 14 15
const mediaPartnerList = [
    {
      name: "Yahoo finance",
      icon: "/images/media/yahoo.svg",
      to: "https://finance.yahoo.com/news/hyra-network-honored-technology-startup-130000762.html",
    },
    {
      name: "Investing.com",
      icon: "/images/media/investing.svg",
      to: "https://www.investing.com/news/cryptocurrency-news/hyra-network-wins-prestigious-chairmans-award-2025-at-witsa-global-ai-summit-4204821",
    },
    {
      name: "Cointelegraph",
      icon: "/images/media/cointele.svg",
      to: "https://cointelegraph.com/press-releases/hyra-network-wins-prestigious-chairman-s-award-2025-at-witsa-global-ai-summit",
    },
    {
      name: "Binance Square",
      icon: "/images/media/binance.svg",
      to: "https://www.binance.com/square/post/28616082089698",
    },
    {
      name: "Benzinga",
      icon: "/images/media/benzinga.svg",
      to: "https://www.benzinga.com/pressreleases/25/08/47258102/hyra-network-wins-prestigious-chairmans-award-2025-at-witsa-global-ai-summit",
    },
    {
      name: "Decrypt",
      icon: "/images/media/decrypt.svg",
      to: "https://decrypt.co/336240/hyra-network-wins-prestigious-chairmans-award-2025-at-witsa-global-ai-summit",
    },
    {
      name: "Business Insider",
      icon: "/images/media/business.svg",
      to: "https://markets.businessinsider.com/news/currencies/hyra-network-wins-prestigious-chairman-s-award-2025-at-witsa-global-ai-summit-1035061414",
    },
    {
      name: "Techbullion",
      icon: "/images/media/egabid-3.svg",
      to: "https://techbullion.com/why-hyra-network-is-the-sleeper-ai-infrastructure-bet-vcs-cant-ignore/",
    },
    {
      name: "Crypto Daily",
      icon: "/images/media/egabid-19.svg",
      to: "https://cryptodaily.co.uk/2025/05/hyra-network-makes-headlines-at-token2049-and-gitex-heres-what-you-missed",
    },
    // {
    //   name: "Coin Market Cap",
    //   icon: "/images/media/egabid-19.svg",
    //   to: "https://coinmarketcap.com/community/articles/681a1ffd8fd1f16046bf6818/",
    //   isLightBackground: true,
    // },
    {
      name: "Coinpedia",
      icon: "/images/media/egabid-4.svg",
      to: "https://coinpedia.org/information/from-dubai-to-singapore-hyra-network-powers-new-frontiers/",
    },
    {
      name: "Cryptowisser",
      icon: "/images/media/egabid-5.svg",
      to: "https://www.cryptowisser.com/hyra-network-accelerates-global-expansion/",
    },
    // {
    //   name: "Wealth Trust Line",
    //   icon: "/images/media/egabid-7.svg",
    //   to: "https://wealthtrustline.com/why-hyra-network-is-the-sleeper-ai-infrastructure-bet-vcs-cant-ignore/",
    // },
    {
      name: "CoinStats",
      icon: "/images/media/egabid-6.svg",
      to: "https://coinstats.app/news/ccfab362893e3b95ce57e1314cf091f64a1e34b6b6938244619aa4cbb479cdaa_From-Dubai-to-Singapore-Hyra-Network-Powers-New-Frontiers-in-Decentralized-AI-and-Strategic-Growth/",
    },
    {
      name: "MorningStar",
      icon: "/images/media/egabid-12.svg",
      to: "https://www.morningstar.com/news/globe-newswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore",
    },
    {
      name: "CBS42",
      icon: "/images/media/egabid-7.svg",
      to: "https://www.cbs42.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
    // {
    //   name: "The Manila Times",
    //   icon: "/images/media/egabid-10.svg",
    //   to: "https://www.manilatimes.net/2025/05/09/tmt-newswire/globenewswire/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/2110180",
    //   isLightBackground: true,
    // },
    {
      name: "GlobeNewswire",
      icon: "/images/media/egabid-13.svg",
      to: "https://www.globenewswire.com/news-release/2025/05/09/3078333/0/en/Hyra-Network-Co-Hosts-TOKEN2049-VC-Summit-and-Showcases-Decentralized-AI-Infrastructure-at-GITEX-Asia-Singapore.html",
      isLightBackground: true,
    },
    {
      name: "WIVB",
      icon: "/images/media/egabid-8.svg",
      to: "https://www.wivb.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
    {
      name: "FOX16",
      icon: "/images/media/egabid-14.svg",
      to: "https://www.fox16.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
    // {
    //   name: "Bakersfield.com",
    //   icon: "/images/media/egabid-14.svg",
    //   to: "https://www.bakersfield.com/ap/news/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at/article_1e339c06-ab2f-5491-a9e6-52e7cef6420f.html",
    //   isLightBackground: true,
    // },
    // {
    //   name: "Beamstart",
    //   icon: "/images/media/egabid-15.svg",
    //   to: "https://beamstart.com/news/hyra-network-co-hosts-token2049-17467994659891",
    //   isLightBackground: true,
    // },
    {
      name: "APNews",
      icon: "/images/media/egabid-17.svg",
      to: "https://apnews.com/press-release/globenewswire-mobile/singapore-asia-23a58a1d69c8ca2778174592d106232a",
    },
    // {
    //   name: "Business Insider",
    //   icon: "/images/media/egabid-17.svg",
    //   to: "https://markets.businessinsider.com/news/stocks/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore-1034699987",
    //   isLightBackground: true,
    // },
    {
      name: "FOX 8",
      icon: "/images/media/egabid.svg",
      to: "https://fox8.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
    {
      name: "WGN-TV [WGN Channel 9]",
      icon: "/images/media/egabid-1.svg",
      to: "https://wgntv.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
    {
      name: "DC News Now",
      icon: "/images/media/egabid-9.svg",
      to: "https://www.dcnewsnow.com/business/press-releases/globenewswire/9447514/hyra-network-co-hosts-token2049-vc-summit-and-showcases-decentralized-ai-infrastructure-at-gitex-asia-singapore/",
    },
  ];



export default function PartnerSection() {
  const t = useTranslations('enterprise');
  const swiperRef = useRef<any>(null);
  return (
    <>
        <section className="py-20 max-sm:px-4">
        <div className="flex flex-col justify-center items-center text-center">
            <Reveal 
                delay={0.1} 
                duration={0.8} 
                direction="left"
                withBlur={true}
                blurAmount={8}
            >
                <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] max-sm:text-[24px]/[32px] text-[#202020] tracking-[-1px]">{t('our-strategic-partnerships')}</h2>
            </Reveal>
            <Reveal 
                delay={0.5} 
                duration={0.8} 
                direction="left"
                withBlur={true}
                blurAmount={8}
            >
                <p className="text-base max-lg:text-sm text-[#646464] font-light mt-[18px] max-w-[552px] mx-auto">{t('partnering-with-leading-tech-blockchain-and-ai-we-provide-secure-scalable-solutions-and-a-seamless-decentralized-ai-ecosystem')}</p>
            </Reveal>
        </div>
        {/* <Swiper
            modules={[Autoplay]}
            spaceBetween={30}
            slidesPerView={5}
            freeMode={true}
            autoplay={{
                delay: 0,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
            }}
            speed={4000}
            loop={true}
            allowTouchMove={false}
            onSwiper={(swiper) => {
              swiperRef.current = swiper;
            }}
            // breakpoints={{
            //     320: { slidesPerView: 2 },
            //     768: { slidesPerView: 3 },
            //     1024: { slidesPerView: 4 }
            // }}
            className=" w-full max-w-[1440px] rounded-lg mt-14 mx-auto"
            style={{
                "--swiper-wrapper-transition-timing-function": "linear"
            } as React.CSSProperties}
        >
            {items.map((item, index) => (
                <SwiperSlide key={index} className="min-w-[200px]">
                    <div onMouseEnter={() => swiperRef.current?.autoplay.stop()}
            onMouseLeave={() => swiperRef.current?.autoplay.start()} className="cursor-pointer bg-[#F9F9F9] py-[24px] px-8 h-[100px] flex justify-center items-center rounded-[8px]">
                        <Image 
                            width={200}
                            height={100}
                            src={item.imgUrl} 
                            alt="Partner Logo"
                            className=" select-none"
                        />
                    </div>
                </SwiperSlide>
            ))}
        </Swiper> */}
        <div className=" w-full max-w-[1440px] rounded-lg mt-14 mx-auto">
          <Marquee autoFill pauseOnHover pauseOnClick>
            {items.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => window.open(item.to, "_blank")}
                className='hover:brightness-90 w-[250px] mr-8 cursor-pointer bg-[#F9F9F9] py-[24px] px-8 h-[100px] flex justify-center items-center rounded-[8px]'
              >
                <Image
                  src={item.imgUrl}
                  alt="logo"
                  width={0}
                  height={0}
                  sizes="100vw"
                  className="h-[48px] w-auto"
                  loading="lazy"
                />
              </div>
            ))}
          </Marquee>
        </div>
    </section>

    {/* partner media section */}
    <section className="py-20 max-sm:px-4">
        <div className="flex flex-col justify-center items-center text-center">
            <Reveal 
                delay={0.1} 
                duration={0.8} 
                direction="left"
                withBlur={true}
                blurAmount={8}
            >
                <h2 className="text-[48px]/[56px] max-lg:text-[32px]/[40px] max-sm:text-[24px]/[32px] text-[#202020] tracking-[-1px]">{t('our-media-partners')}</h2>
            </Reveal>
            <Reveal 
                delay={0.5} 
                duration={0.8} 
                direction="left"
                withBlur={true}
                blurAmount={8}
            >
                <p className="text-base max-lg:text-sm text-[#646464] font-light mt-[18px] max-w-[552px] mx-auto">{t('we-collaborate-with-tech-and-business-outlets-to-share-product-updates-insights-and-customer-stories')}</p>
            </Reveal>
        </div>
        <div className=" w-full max-w-[1440px] rounded-lg mt-14 mx-auto">
          <Marquee autoFill pauseOnHover pauseOnClick>
            {mediaPartnerList.map((item: any, index: number) => (
              <div
                key={index}
                onClick={() => window.open(item.to, "_blank")}
                className='hover:brightness-90 min-w-[250px] mr-8 cursor-pointer bg-[#F9F9F9] py-[24px] px-8 h-[100px] flex justify-center items-center rounded-[8px]'
              >
                <Image
                  src={item.icon}
                  alt="logo"
                  width={0}
                  height={0}
                  sizes="100vw"
                  className="h-[48px] w-auto"
                  loading="lazy"
                />
              </div>
            ))}
          </Marquee>
        </div>
    </section>
    </>
  )
}
